module.exports = __webpack_public_path__ + "static/muckraker-d5f63b36b63a72a09004656ca8ed600d.png";